const root = 'MarketplacePage'

export const TestId = {
  resultsLoaded: `${root}-resultsLoaded`,
}
